/* eslint-disable @typescript-eslint/no-explicit-any */
import { cloneDeep } from 'lodash';
import { filterTypes, globalTypes } from '../reduxExports';
import rmsStore from '../rmsStore';
import { alarmInitialFilterValues, chargerInitialFilterValues, usersInitialFilterValues, globalFiltersInitialState, configureNotificationInitialFilterValues, configureNotificationHistoryInitialFilterValues, ruleEngineInitialFilterValues, ruleEngineHistoryInitialFilterValues, executionSummaryRuleEngineFormInitialFilterValues, versionReleasesInitialFilterValues, versionReleasesDashboardInitialFilterValues, deploymentLogsDashboardInitialFilterValues, overallUptimeInitialFilterValues, failedTransactionInitialFilterValues, chargingSessionTrendInitialFilterValues, chargingVsIdleInitialFilterValues, chargingHistoryReportInitialFilterValues, sessionHistoryReportInitialFilterValues, nocDashboardInitialFilterValues, nocPerfomanceAnalyticsIntialFilterValues,latestChargerStatusLogsInitialFilterValues, rmsSupportAlarmTroubleshootingInititalFilterValues, rmsSupportStopReasonCodeTroubleshootingInititalFilterValues, rmsSupportDocumentationInitialFilterValues, alarmEventsInitialFilterValues, uptimeReportInitialFilterValues, statusHistoryReportInitialFilterValues, advanceRuleEngineInititalFilterValues, advanceRuleEngineHistoryInititalFilterValues, derivedConditionsInititalFilterValues, advanceRuleExecutionSummaryInitialValues, chargerCertificatesInfoInitialValues, advanceRuleTriggerLogsInitialValues, adminPasswordUpdateLogsFilterInitialValues, inventoryParamsChangeLogsFilterInitialValues, inventoryParamsHistoryReportFilterInitialValues, inventoryParamsLatestLogsReportFilterInitialValues, inventoryParamsChangeLogsReportFilterInitialValues } from './filterReducer';

export const setFilterData = (data, filterKey: string, screenName: string, action: 'SET' | 'CLEAR', isGlobal: boolean, excludeGlobalFilters?: boolean,clearGlobalFilters?:boolean) => async (dispatch): Promise<FilterUpdateResolve> => {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
        try {
            let globalFilters: InnerFilterState[] = cloneDeep(rmsStore.getState().filterReducer.globalFilters);
            const screenFilters: ScreenFilterState[] = cloneDeep(rmsStore.getState().filterReducer.screenFilters);

            if (isGlobal) {
                const selectedGlobalFilter = globalFilters?.find((filter) => filter?.key === filterKey);
                if (selectedGlobalFilter) {
                    selectedGlobalFilter.value = Array.isArray(data) ? data : [data]
                }
                const action: Partial<FilterDataAction> = {
                    type: filterTypes.SET_GLOBAL_FILTERS_DATA,
                    globalFilters: globalFilters,
                };
                await dispatch(action);
            }

            if (action === 'SET' && !isGlobal) {
                const selectedScreenFilters = screenFilters?.find((filter) => filter?.screen === screenName);
                const selectedScreenSelectedFilter = selectedScreenFilters?.filters?.find((filter => filter?.key === filterKey));
                if (selectedScreenSelectedFilter) {
                    selectedScreenSelectedFilter.value = Array.isArray(data) ? data : [data]
                }
                const action: Partial<FilterDataAction> = {
                    type: filterTypes.SET_SCREEN_FILTERS_DATA,
                    screenFilters: screenFilters,
                };
                await dispatch(action);
            }

            /* CLEAR ACTION WILL COME ONLY WHEN ALARMS OR CHARGERS DASHBOARD ARE UNMOUNTED
                AND FILTERS WERE APPLIED FROM REDIRECTION */
            if (action === 'CLEAR') {
                if(clearGlobalFilters) {
                    globalFilters = globalFiltersInitialState
                    const globalAction: Partial<FilterDataAction> = {
                        type: filterTypes.SET_GLOBAL_FILTERS_DATA,
                        globalFilters: globalFilters,
                    };
                    await dispatch(globalAction);
                }
                const initialScreenFilterValues = {
                    'chargers': chargerInitialFilterValues,
                    'alarms': alarmInitialFilterValues,
                    'alarmEvents':alarmEventsInitialFilterValues,
                    'users': usersInitialFilterValues,
                    'configureNotification': configureNotificationInitialFilterValues,
                    'configureNotificationHistory': configureNotificationHistoryInitialFilterValues,
                    'ruleEngine' : ruleEngineInitialFilterValues,
                    'ruleEngineHistory': ruleEngineHistoryInitialFilterValues,
                    'executionSummaryRuleEngineForm': executionSummaryRuleEngineFormInitialFilterValues,
                    'versionReleases': versionReleasesInitialFilterValues,
                    'versionReleasesDashboard':versionReleasesDashboardInitialFilterValues,
                    'softwareVersionDeploymentLogs':deploymentLogsDashboardInitialFilterValues,
                    'overAllUptime':overallUptimeInitialFilterValues,
                    'failedTransaction':failedTransactionInitialFilterValues,
                    'chargingSessionTrend':chargingSessionTrendInitialFilterValues,
                    'chargingVsIdle':chargingVsIdleInitialFilterValues,
                    'chargingHistoryReport':chargingHistoryReportInitialFilterValues,
                    'sessionHistoryReport': sessionHistoryReportInitialFilterValues,
                    'uptimeReports':uptimeReportInitialFilterValues,
                    'nocDashboard': nocDashboardInitialFilterValues,
                    'nocPerfomanceAnalytics':nocPerfomanceAnalyticsIntialFilterValues,
                    'latestChargerStatusLogs':latestChargerStatusLogsInitialFilterValues,
                    'rmsSupportAlarmTroubleshooting': rmsSupportAlarmTroubleshootingInititalFilterValues,
                    'rmsSupportStopReasonCodeTroubleshooting': rmsSupportStopReasonCodeTroubleshootingInititalFilterValues,
                    'rmsSupportDocumentation': rmsSupportDocumentationInitialFilterValues,
                    'statusHistoryReport': statusHistoryReportInitialFilterValues,
                    'advanceRuleEngine': advanceRuleEngineInititalFilterValues,
                    'advanceRuleEngineHistory': advanceRuleEngineHistoryInititalFilterValues,
                    'derivedConditions': derivedConditionsInititalFilterValues,
                    'advanceRuleExecutionSummary': advanceRuleExecutionSummaryInitialValues,
                    'advanceRuleTriggerLogs': advanceRuleTriggerLogsInitialValues,
                    'chargerCertificates':chargerCertificatesInfoInitialValues,
                    'adminPasswordUpdateLogs': adminPasswordUpdateLogsFilterInitialValues,
                    'inventoryParamChangeLogs': inventoryParamsChangeLogsFilterInitialValues,
                    'inventoryParamHistoryReport': inventoryParamsHistoryReportFilterInitialValues,
                    'inventoryParamLatestLogsReport': inventoryParamsLatestLogsReportFilterInitialValues,
                    'inventoryParamChangeLogsReport': inventoryParamsChangeLogsReportFilterInitialValues
                }
                const selectedScreenFilters = screenFilters?.find((filter) => filter?.screen === screenName);
                if (selectedScreenFilters) {
                    selectedScreenFilters.filters = initialScreenFilterValues[screenName]
                }
                const action: Partial<FilterDataAction> = {
                    type: filterTypes.SET_SCREEN_FILTERS_DATA,
                    screenFilters: screenFilters,
                };
                await dispatch(action);
            }
            const globalFiltersToBeSent: Filters[] = globalFilters?.map((item) => {
                return {
                    key: item.key,
                    values: item.value?.map((item) => item.id) || []
                }
            })
            const screenFiltersToBeSent: Filters[] = screenFilters?.find((filter) => filter.screen === screenName)?.filters.map((item) => {
                if (item.key === 'uptimeQuickDateRange') {
                    return {
                    key: item.key,
                    values: item.value?.map(v => v?.value ?? v) || []
                    };
                }
                  if (item.key === 'nocTimeSelectionInterval') {
                    return {
                    key: item.key,
                    values: item.value?.map(v => v?.value ?? v) || []
                    };
                }
                if (
                    item.key === 'alarmClearedTimeStamp' || item.key === 'alarmSetTimeStamp' || item.key === 'setInterval' || item.key === 'updateInterval' || item.key === 'chargingHistoryInterval' || item.key === 'chargerLogStatusInterval' || item.key === 'chargerLogSettingInterval' || item.key === 'chargerLogSystemLogInterval' || item.key === 'logInterval' || item.key === 'stationUpdateInterval' || item.key === 'fireTime' || item.key==='fireTimeRangeInterval'|| item.key ==='setIntervalUpdateCommand' || item.key==='versionReleaseDateInterval' || item.key === 'swVersionRequestedOnInterval' || item.key==='chargingSessionHistoryInterval' || item.key === 'alarmRuleCreatedAtInterval' || item.key === 'alarmRuleUpdatedAtInterval' || item.key === 'rmsSupportUploadedDateInterval' || item.key === 'rmsSupportDocumentUpdatedAtInterval' || item.key === 'alarmEventSetAtInterval' || item.key == 'alarmEventClearedAtInterval' || item.key == 'uptimeReportDateRangeInterval' 
                    || item.key === 'advanceRuleEngineCreatedAtInterval' || item.key === 'advanceRuleEngineUpdatedAtInterval' || item.key === 'advanceRuleEngineFireTimeRangeInterval'  || item.key === 'advanceRuleTriggerLogsTimeRangeInterval' || item.key === 'derivedConditionCreatedAtInterval' || item.key === 'derivedConditionUpdatedAtInterval' || item.key === 'certificateExpiryIntervalRange' || item.key === 'certificateCreatedAtInterval'
                    || item.key === 'adminPasswordUpdateRequestedOn' || item.key === 'changeLogLoggedAt' || item.key === 'inventoryParamHistoryDateRange'
                ) {
                    if (item.key === 'fireTime') {
                        return {
                            key: item.key,
                            values: ['custom', ...item.value?.map(item => item && new Date(item)?.toISOString()) || []]
                        };
                    } else
                        return {
                            key: item.key,
                            values: item.value?.map(item => item && new Date(item)?.toISOString()) || []
                        }

                } else if (item.key === 'historyInterval' && (item?.value?.[0] as IChargerHistoryIntervalRefData)?.id === 'custom') {
                    return {
                        key: item.key,
                        values: item?.value?.map((item, index) => { return index === 0 ? item?.id : new Date(item)?.toISOString() }) || []
                    }
                } 
                return {
                    key: item.key,
                    values: item.value?.map((item) => item?.id) || []
                }
            }) || []
            const filtersToBeSent = excludeGlobalFilters ? [...screenFiltersToBeSent] : [...globalFiltersToBeSent, ...screenFiltersToBeSent];
            resolve({
                message: 'Action dispatched successfully',
                filters: filtersToBeSent
            });
        } catch (error) {
            // Reject the promise with the error
            reject(error);
        }
    });
};

export const getFilterSelectedValue: any = (filterKey: string, screenName: string, isGlobal): null | IChargerHistoryTypeRefData[] | IChargerHistoryIntervalRefData[] | IGeneralReferenceData[] | IDateRangeReferenceData[]|string[] => {
    const globalFilters: InnerFilterState[] = cloneDeep(rmsStore.getState().filterReducer.globalFilters);
    const screenFilters: ScreenFilterState[] = cloneDeep(rmsStore.getState().filterReducer.screenFilters);

    if (isGlobal) {
        return globalFilters?.find((filter) => filter?.key === filterKey)?.value || null;
    }
    const selectedScreenFilters = screenFilters?.find((filter) => filter?.screen === screenName);
    return selectedScreenFilters?.filters?.find((filter => filter?.key === filterKey))?.value || null
}

export const getCurrentFiltersValues: any = (screenName: string, excludeGlobalFilters?: boolean): Filters[] => {
    const globalFilters: InnerFilterState[] = cloneDeep(rmsStore.getState().filterReducer.globalFilters);
    const screenFilters: ScreenFilterState[] = cloneDeep(rmsStore.getState().filterReducer.screenFilters);
    const globalFiltersToBeSent: Filters[] = globalFilters?.map((item) => {
        return {
            key: item.key,
            values: item.value?.map((item) => item.id) || []
        }
    })
    const screenFiltersToBeSent: Filters[] = screenFilters?.find((filter) => filter.screen === screenName)?.filters?.map((item) => {
        if (item.key === 'uptimeQuickDateRange') {
                    return {
                    key: item.key,
                    values: item.value?.map(v => v?.value ?? v) || []
                    };
        }
        if (item.key === 'nocTimeSelectionInterval') {
                    return {
                    key: item.key,
                    values: item.value?.map(v => v?.value ?? v) || []
                    };
        }
        if (
            item.key === 'alarmClearedTimeStamp' || item.key === 'alarmSetTimeStamp' || item.key === 'setInterval' || item.key === 'updateInterval' || item.key === 'chargingHistoryInterval' || item.key === 'chargerLogStatusInterval' || item.key === 'chargerLogSettingInterval' || item.key === 'chargerLogSystemLogInterval' || item.key === 'logInterval' || item.key === 'stationUpdateInterval' || item.key === 'fireTime' || item.key==='fireTimeRangeInterval'  || item.key ==='setIntervalUpdateCommand' || item.key === 'versionReleaseDateInterval' || item.key === 'swVersionRequestedOnInterval' || item.key === 'chargingSessionHistoryInterval' || item.key === 'alarmRuleCreatedAtInterval' || item.key === 'alarmRuleUpdatedAtInterval' || item.key === 'rmsSupportUploadedDateInterval' || item.key === 'rmsSupportDocumentUpdatedAtInterval' ||item.key === 'alarmEventSetAtInterval' || item.key == 'alarmEventClearedAtInterval' || item.key == 'uptimeReportDateRangeInterval'
            || item.key === 'advanceRuleEngineCreatedAtInterval' || item.key === 'advanceRuleEngineUpdatedAtInterval' || item.key === 'advanceRuleEngineFireTimeRangeInterval'   || item.key === 'advanceRuleTriggerLogsTimeRangeInterval' || item.key === 'derivedConditionCreatedAtInterval' || item.key === 'derivedConditionUpdatedAtInterval' || item.key === 'certificateExpiryIntervalRange' || item.key === 'certificateCreatedAtInterval'
            || item.key === 'adminPasswordUpdateRequestedOn' || item.key === 'changeLogLoggedAt' || item.key === 'inventoryParamHistoryDateRange'
        ) {
            return {
                key: item.key,
                values: item.value?.map(item => item && new Date(item)?.toISOString()) || []
            }
        }
        else if (item.key === 'historyInterval' && (item?.value?.[0] as IChargerHistoryIntervalRefData)?.id === 'custom') {
            return {
                key: item.key,
                values: item?.value?.map((item, index) => { return index === 0 ? item?.id : new Date(item)?.toISOString() }) || []
            }
        }
        return {
            key: item.key,
            values: item.value?.map((item) => item?.id) || []
        }
    }) || []

    const filtersToBeSent = excludeGlobalFilters ? [...screenFiltersToBeSent] : [...globalFiltersToBeSent, ...screenFiltersToBeSent]
    return filtersToBeSent
}

export const getCurrentScreenAppliedFiltersCount: any = (screenName: string, excludeGlobalFilters?: boolean): number => {
    const globalFilters = rmsStore.getState().filterReducer.globalFilters;
    const screenFilters = rmsStore.getState().filterReducer.screenFilters;
    let globalFilterCount: number = 0
    globalFilters?.map((item) => {
        globalFilterCount += item?.value && item?.value?.length > 0 ? 1 : 0
    })
    let screenFilterCount: number = 0
    screenFilters?.find((filter) => filter.screen === screenName)?.filters.map((item) => {
        screenFilterCount += item?.value && item?.value?.length > 0 && item?.value?.[0] ? 1 : 0
    })
    const appliedFiltersCount = excludeGlobalFilters ? screenFilterCount : screenFilterCount + globalFilterCount
    return appliedFiltersCount
}


export const setFilterForDefaultValues: any = (data, filterKey: string, screenName: string, action: 'SET' | 'CLEAR', isGlobal: boolean) => async (dispatch: (arg0: Partial<FilterDataAction>) => void): Promise<void> => {
    const setupDefaultFilterConfig: boolean = rmsStore.getState().globalReducer.setupDefaultFilterConfig;
    if (setupDefaultFilterConfig === false) { return }
    await setFilterData(data, filterKey, screenName, action, isGlobal)(dispatch)
    const globalAction: Partial<GlobalDataAction> = {
        type: globalTypes.SET_DEFAULT_FILTER_CONFIG_FLAG,
        setupDefaultFilterConfig: false
    }
    dispatch(globalAction);
}
